import { ReportContentNS } from 'components/report-content/index';
import RendererFilter = ReportContentNS.RendererFilter;

const formFieldPrefix = '__field__name_';

export function getFieldOptionForFormName(field: RendererFilter, option: string) {
    return formFieldPrefix + field.column_name + '_' + option;
}
